module.exports = __webpack_public_path__ + "../static/img/hn.4210459f.png";